import HTTPService from '@/api/base/HTTPService'

const PAPERCUT_API_VERSION_ROOT = '/api/v1'
export const PAPERCUT_API_URL = `${process.env.VUE_APP_PAPERCUT_URL}${PAPERCUT_API_VERSION_ROOT}`

// Catering order + capacity paths owned by this backend. GrainCoreApi defines
// the same surface under its own base, so callers ask the chosen backend for the
// path (route knowledge stays in the service, not at the call site).
export const PAPERCUT_CATERING_PATHS = {
  orders: () => `${PAPERCUT_API_URL}/orders`,
  orderReferredBy: (orderId) => `${PAPERCUT_API_URL}/orders/${orderId}/referred_by`,
  timeSlots: (date) => `${PAPERCUT_API_URL}/time_slots/${date}`,
  closedHours: () => `${PAPERCUT_API_URL}/closed_hours`,
  locationConfigs: () => `${PAPERCUT_API_URL}/location_configs`,
  salesRepresentatives: () => `${PAPERCUT_API_URL}/sales_representatives`
}

const PLATFORM = 'catering'

const PapercutApi = HTTPService()
PapercutApi.setup({
  getPlatform() {
    return PLATFORM
  },
  getAuthorizationKey: () => {
    return process.env.VUE_APP_PAPERCUT_API_KEY
  }
})
export default PapercutApi
